export default __webpack_public_path__ + "static/media/img2.0ddb4751.webp";